import { EnvContextType, withEnv } from '@acorns/web-utils'
import { compose } from 'recompose'

import { SplitDepositSettingType } from 'generated/types'
import { prefetchQueries } from 'utils/queries'

import * as queries from './queries'

const queryVariables = new Map([
  [
    'investmentTotalsQuery',
    {
      settingTypes: [
        SplitDepositSettingType.DirectDeposit,
        SplitDepositSettingType.DirectDepositIntent,
      ],
    },
  ],
])

export const prefetchPresentScreenQueries = compose(
  withEnv,
  prefetchQueries<EnvContextType>(
    Object.entries(queries).map(([queryName, query]) => ({
      query,
      variables: queryVariables.get(queryName) ?? {},
    })),
    undefined,
    ['/', '/present'],
    (props) => props.env.get('graphqlBatchingEnabled') === 'false',
  ),
)
